export default "__VITE_ASSET__Bbyc1iBS__"